import { useTranslation } from 'react-i18next'
import { useActiveLoanForBook } from '@/hooks/loans'
import type { Book } from '@/types'

/** "Borrowed from X" / "With X since …" line on a book card */
export function BookLoanBadge({ book }: { book: Book }) {
  const { t, i18n } = useTranslation()
  const loan = useActiveLoanForBook(book.id)
  const since = loan
    ? new Intl.DateTimeFormat(i18n.language, { day: 'numeric', month: 'short' }).format(
        new Date(`${loan.lent_on}T00:00:00`)
      )
    : null

  if (loan && loan.book_id === book.id) {
    return (
      <span className="inline-flex max-w-full items-center gap-1 truncate rounded-full bg-warning/10 px-2 py-0.5 text-xs font-medium text-warning">
        📤 {t('loans.lentTo', { name: loan.borrower_name, date: since })}
      </span>
    )
  }

  if (book.ownership === 'borrowed') {
    return (
      <span className="inline-flex max-w-full items-center gap-1 truncate rounded-full bg-info/10 px-2 py-0.5 text-xs font-medium text-info">
        📥{' '}
        {book.borrowed_from
          ? t('loans.borrowedFrom', { name: book.borrowed_from })
          : t('loans.borrowed')}
        {!loan && book.borrowed_from && ` · ${t('loans.returned')}`}
      </span>
    )
  }

  return null
}
